import { render, staticRenderFns } from "./about-dialog.vue?vue&type=template&id=860dc9f2"
import script from "./about-dialog.vue?vue&type=script&lang=js"
export * from "./about-dialog.vue?vue&type=script&lang=js"
import style0 from "./about-dialog.vue?vue&type=style&index=0&id=860dc9f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports